import { BaseFieldRenderer } from './base-field-renderer';
import { BirthdayFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class BirthdayFieldRenderer extends BaseFieldRenderer<BirthdayFieldJsonData> {
    protected override get defaultData(): BirthdayFieldJsonData {
        return {
            id: '',
            type: 'birthday',
            label: TranslateUtils.BIRTHDAY_FIELD.LABEL,
            format: TranslateUtils.BIRTHDAY_FIELD.FORMAT,
            placeholder: TranslateUtils.BIRTHDAY_FIELD.PLACEHOLDER,
            required: false,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'DateTime',
                systemName: 'Birthday',
                name: 'Birthdate'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: BirthdayFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 11;
        input.dataset['format'] = fieldJsonData.format || TranslateUtils.BIRTHDAY_FIELD.FORMAT;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
